import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Platform, Events } from 'ionic-angular';
import { AppState } from '../../config/state';
import { EventsProvider } from '../../providers/events/events';
import moment from 'moment';
import { VirtualScrollerComponent } from 'ngx-virtual-scroller';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { CoSelfcheckAccountPage } from '../co-selfcheck-account/co-selfcheck-account';
import { FilteringProvider } from '../../providers/filtering/filtering';
import { CoEventCategoryFilteringComponent } from '../../components/co-event-category-filtering/co-event-category-filtering';
import { CoSelfcheckCheckoutPage } from '../co-selfcheck-checkout/co-selfcheck-checkout';

/**
 * Generated class for the CoEventFinderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-co-event-finder',
  templateUrl: 'co-event-finder.html'
})
export class CoEventFinderPage {
  private finderStage = 'choose';
  private listMessage = '';
  private brochureMessage = '';
  private events = [];
  private currentDensity = 0;
  @ViewChild('CoEventCategoryFilteringComponent') private filterComponent :CoEventCategoryFilteringComponent;
  @ViewChild(VirtualScrollerComponent)
  private virtualScroller: VirtualScrollerComponent;
	private dateRangeDisplay: any = {lower: '', upper: ''};
	private eventCount: any;
	private isSubscription: string = 'email';
	private termsAccepted: boolean = false;
	private branchList: any;
	private isNameSearch: boolean = false;
	private email: string;
	private setFilters: any;
	private subscribeTime: any;
	private unregisterBackButtonAction: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private platform: Platform,  private state: AppState, private eventsProvider: EventsProvider, private loadingCtrl: LoadingController, private toast : ToastAlertsProvider, private filter : FilteringProvider, private _events: Events) {
  }
//   ionViewCanLeave(){
// 	if(this.finderStage==='choose'){
// 		return true;
// 	}
// 	this.finderStage='choose';
// 	return false;
//   }

  ionViewDidEnter() {
	this.unregisterBackButtonAction = this.platform.registerBackButtonAction( () => {
		if(this.finderStage === 'list') this.finderStage = 'choose';
		else if(this.finderStage === 'email') this.finderStage = 'list';
		else this.closeFinder();
	}, 10);
	this._events.subscribe('interestedEventAdded', (event) => {
		const toUpdate = this.events.find( e => e.eventId === event.eventId );
		if(toUpdate) toUpdate.interested = true;
	});
	this._events.subscribe('interestedEventRemoved', (event) => {
		const toUpdate = this.events.find( e => e.eventId === event.eventId );
		if(toUpdate) toUpdate.interested = false;
	});
  }
  ionViewWillLeave() {
	this.unregisterBackButtonAction();
  }

  findEvents(start, end, ages, types, branches, branch, timeRanges, nameSearch) {
		let loader = this.loadingCtrl.create({
			content:"Retrieving events..."
		});
		loader.present();
		// console.log(start, end);
		if (nameSearch){
			this.isNameSearch = true;
			this.eventsProvider.getEvents(`startDate: "${moment().startOf('day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment().add(30, 'days').endOf('day').format("YYYY-MM-DD HH:mm:ss")}"`).then(events=>{
				this.filter.filterByPopover({keyword: nameSearch}, events.allEvents).then(e =>{
					loader.dismiss().catch(err=>{});
					this.events = e;
					this.listMessage = `Showing events related to <span>${nameSearch}</span>`;
					this.finderStage = 'list';
				});
			});
		} else {
			let isLocation;
			if (branches.length === 1){
				isLocation =`, locationId: ${branches[0]}`;
			} else {
				isLocation = '';
			}
			this.eventsProvider.getEvents(`startDate: "${start}", endDate: "${end}"${isLocation}`).then(events=>{
				loader.dismiss().catch(err=>{});
				this.events = events.allEvents;
				if(ages.length>0) this.events = this.events.filter(e=>{
					if (e.ages) return e.ages.some(a=>ages.indexOf(a) >= 0);
				});
				if(types.length>0) this.events = this.events.filter(e=>{
					if (e.types) return e.types.some(t=>types.indexOf(t) >= 0);
				});
				if(branches.length > 1) this.events = this.events.filter(e=>branches.includes(e.locationId));
				if(timeRanges && timeRanges.length>0){
					this.events = this.events.filter(e=>{
						let ok=false;
						timeRanges.forEach(time => {
							if(moment(e.eventStart).isSameOrAfter(moment(e.eventStart).hour(time.lower.hour).minute(time.lower.minute)) && moment(e.eventStart).isSameOrBefore(moment(e.eventEnd).hour(time.upper.hour).minute(time.upper.minute))){
								ok = true;
							}
						});
						return ok;
					});
				}
				if(this.events.length===0){
					this.toast.showAlert("", "Sorry no events match your selection.");
				}else{
					const typesString = types.length>0? types.length : 'All';
					const agesString = ages.length > 0 ? `<span>${ages.length}</span> age groups ` : '<span>All ages</span>';
					let names = [];
					branches.forEach(b => {
						names.push(this.branchList.find(branch => branch.id == b).name);
					});
					let branchName = branches.length > 0? branches.length : 'All';
					this.listMessage = `Showing <span>${typesString}</span> event types for ${agesString} at <span>${branchName} branches</span>`;
					this.brochureMessage = `<span>${typesString}</span> event types for ${agesString} at <span>${branchName} branches</span>`
					this.finderStage = 'list';
				}
			});
		}
  }
  closeFinder(){
		this.state.nav.popToRoot();
	}
	myAccount(){
		this.state.nav.push(CoSelfcheckAccountPage);
	}
	getFilters(filters){
		this.findEvents(filters.start, filters.end, filters.ages, filters.types, filters.locations, filters.selectedLocation, filters.timeRanges, filters.nameSearch);
		this.dateRangeDisplay = {lower: filters.start, upper: filters.end};
		this.setFilters = filters;
		this.eventCount = filters.eventCount;
		this.branchList = filters.branchList;
	}
	refineSearch(){
		this.finderStage = 'choose';
	}
	sendEmail(){
		let loader = this.loadingCtrl.create({content: "Generating brochure..."});
		loader.present();
		let brochureData = {
      format: 'email',
      end_date: moment(this.dateRangeDisplay.upper).format("YYYY-MM-DD"),
      start_date: moment(this.dateRangeDisplay.lower).format("YYYY-MM-DD"),
      email: this.email,
      ages: this.setFilters.ages.length > 0? this.setFilters.ages : ["all"],
      types: this.setFilters.types.length > 0? this.setFilters.types : ["all"],
      location: this.setFilters.locations.length > 0? this.setFilters.locations : ["all"],
			type: 1,
			clientId : this.state.client.id
    };
		fetch(`https://${this.state.client.keyword}.libnet.info/brochure_generator`, {
      method: 'post',
      body: JSON.stringify({brochuredata: brochureData}),
      headers: {'Content-Type': 'application/json'}
    }).then(res => res.json()).then(result =>{
			loader.dismiss().catch(err=>{});
      if (result.sent){
				this.toast.showAlert("",result.message||"Successfully sent brochure", "success",5000);
			} else {
				this.toast.showAlert("",result.message||"Failed to send brochure to this email address.");
			}
    }).catch(err => {
			this.toast.showAlert("","Failed to send brochure to this email address."||"Successfully sent brochure", 'warning',5000);
			console.log('Error sending brochure ' + err);
			loader.dismiss().catch(err=>{});
		});
	}
	subscribeBrochure(){
		let loader = this.loadingCtrl.create({content: "Generating brochure..."});
		loader.present();
		let brochureData = {
      format: 'subscription',
      end_date: moment(this.dateRangeDisplay.upper).format("YYYY-MM-DD"),
      start_date: moment(this.dateRangeDisplay.lower).format("YYYY-MM-DD"),
      email: this.email,
      ages: this.setFilters.ages.length > 0? this.setFilters.ages : ["all"],
      types: this.setFilters.types.length > 0? this.setFilters.types : ["all"],
      location: this.setFilters.locations.length > 0? this.setFilters.locations : ["all"],
			type: 1,
			clientId : this.state.client.id,
			subscription: {
				months: 0,
				days: 0,
				weeks: 0,
				frequency: '',
				run_date: null,
				filters: null
			},
		};

			var self = this;
			var days = 0;
			var weeks = 0;
			var months = 0;
			var sd = moment(this.dateRangeDisplay.lower);
			var ed = moment(this.dateRangeDisplay.upper);
			// Then we have successfully made it to the end of the function and can start mathing.
			var d  = Math.abs(sd.diff(ed, 'days'));
			var w  = Math.abs(sd.diff(ed, 'weeks'));
			// Months we need to get decimal representation;
			var m  = Math.abs(sd.diff(ed, 'months', true));
			if(m > 0.8) m = 1;
			var message = "  After this brochure, you will receive one every ";
			var bs = ed.add(1, 'days');
			// console.log('diffs[ d:' + d.toString() + ', w: ' + w.toString() + ', m: ' + m.toString());
			if(d > 1) {
				if(m >= 1) {
					message += "month. Starting on " + bs.format('MMMM Do, YYYY');
					brochureData.subscription.months = 1;
					brochureData.subscription.frequency = 'monthly';
				} else {
					if (w === 0) w = 1;
					message += w.toString() + " week(s). Starting on " + bs.format('MMMM Do, YYYY');
					brochureData.subscription.weeks = w;
					brochureData.subscription.frequency = 'weeks';
				}
			} else {
				message += d.toString() + " day(s). Starting on " + bs.format('MMMM Do, YYYY');
				brochureData.subscription.days = d;
				brochureData.subscription.frequency = 'days';
			}
			brochureData.subscription.run_date = bs.format('YYYY-MM-DD');

			brochureData.subscription.filters = {
				ages: brochureData.ages,
				types: brochureData.types,
				locations: brochureData.location,
				date: this.dateRangeDisplay.lower,
				days: days,
				weeks: weeks,
				months: months
			}

			// fetch(`https://api.communico.co/v2/brochure/methods/subscribe`, {
			fetch(`https://api.communico.co/v2/brochure/methods/subscribe`, {
		// return fetch('https://api-colin.communico.co/v2/checkin', {
			method: 'post',
			// body: JSON.stringify({brochuredata: brochureData, clientId: 157}),
			body: JSON.stringify({brochuredata: brochureData, clientId: this.state.client.id}),
			headers: {'Content-Type': 'application/json'}
		}).then(res => res.json()).then(result =>{
			loader.dismiss().catch(err=>{});
			if (result.sent){
				this.toast.showAlert("",result.message||"Successfully sent brochure", "success",5000);
			} else {
				this.toast.showAlert("",result.message||"Failed to send brochure to this email address.");
			}
		}).catch(err => {loader.dismiss().catch(err=>{})});
	}

	// this is for the header button
	itemCheckout(){
		this.state.nav.push(CoSelfcheckCheckoutPage);
	}
}



// WEBPACK FOOTER //
// ./src/pages/co-event-finder/co-event-finder.ts